import { UUID } from '@macs-frontend/core/utils/uuid';
import { BaseChannelSelector } from '@macs-frontend/web-macs/shared/models/channel-selector.model';

export interface BaseBudgetItem<T extends BudgetItemTypes> {
  uuid: UUID;
  name: string;
  description?: string;
  qty: number;
  discount: number;
  unitPrice: number;
  billablePrice: number;
  margin: number;
  oldPrice: number;
  amount: number;
  isActive: boolean;
  type: T;
}

export type BudgetItem<T extends BudgetItemTypes> = T extends BudgetItemTypes.FEES
  ? BaseBudgetItem<T> & {
      channelSelector: BaseChannelSelector;
    }
  : BaseBudgetItem<T>;

export enum BudgetItemTypes {
  STAFFING_COST = 'staffing-cost',
  GROUP_STAFFING_COST = 'group-staffing-cost',
  DEFAULT_STAFFING_COST = 'default-staffing-cost',
  TEAM_COST = 'team-cost',
  DEFAULT_TEAM_COST = 'default-team-cost',
  FEES = 'fees',
  MATERIAL_COST = 'material-cost',
  DEFAULT_MATERIAL_COST = 'default-material-cost',
  WAREHOUSE = 'warehouse',
}

export interface BudgetItemForServer {
  unitPrice: number;
  discount: number;
  billablePrice?: number;
}
